import { brands } from './brands'
import { general } from './general'
import { yolorekt } from './yolorekt'
import { crypto } from './crypto'
import { home } from './home'

export const collections = {
  brands,
  general,
  yolorekt,
  crypto,
  home,
}
